/**
 * Pointer card for a platform-admin session that opens Support here.
 *
 * GH #678 (operator ruling 2026-10-23): the Support operator tooling (the
 * cross-institution case queue, the SLA rule editor, the agent roster, and
 * status, priority, escalate and transfer on case detail) lives in the Aaim
 * operator console, platform-admin (platform.aaim.com, Support). This portal
 * keeps what staff of one institution use: their own case queue, case detail
 * with reply, and New case.
 *
 * The support service refuses every platform-admin caller on
 * /api/v1/support/fi-cases (aaim-core services/support fi-cases.routes.ts,
 * authorizeFiOperator), so a session holding a platform-admin role has no
 * queue this portal can show. It gets this card instead, whether or not it
 * also holds an FI role.
 *
 * Text pointer only: no link and no env-var host. The operator console host
 * is named as text so nothing here bakes a deploy-specific URL.
 */

import { BodyText, Card, Heading } from '@aaimplatform/ui';

export function SupportOperatorConsolePointer() {
  return (
    <div className="p-6 space-y-4">
      {/* Page title lives in the sticky topnav (AppHeader); no redundant H1. */}
      <Card>
        <div className="p-4 space-y-2">
          <Heading level={2} as={3} size="card">
            Case operations live in the Aaim operator console
          </Heading>
          <BodyText size="sm" color="secondary">
            Open Support on platform.aaim.com to work the case queue across every
            institution, change a case&rsquo;s status or priority, escalate or transfer
            it, and manage SLA rules and the agent roster.
          </BodyText>
          <BodyText size="sm" color="secondary">
            Support in this portal serves staff of one institution: their own cases,
            replies on those cases, and new cases.
          </BodyText>
        </div>
      </Card>
    </div>
  );
}
